/* eslint-disable max-len */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import UserDetailDisplay from './UserDetailDisplay';
import UserDetailEdit from './UserDetailEdit';
import UserChangePassword from './UserChangePassword';
import UserUpdateDetails from './UserUpdateDetails';
import ChangeAccountOwner from './ChangeAccountOwner';
import CommunicationSettings from './contact-agreement/CommunicationSettings';

const getRoleForCurrentAccount = (roles, currentAccountId) => {
  let userRole;

  roles.forEach((role) => {
    const accountId = role.account.id;

    if (accountId === currentAccountId) {
      userRole = role.role.name;
    }
  });

  return userRole;
};

const UserDetail = ({ accountId, viewerId, viewerRole, user, accountLegalName }) => {
  const [updateRolesFlag, setUpdateRolesFlag] = useState(false);
  const [changeOwnerFlag, setChangeOwnerFlag] = useState(false);
  const [changePasswordFlag, setChangePasswordFlag] = useState(false);
  const [updateDetailsFlag, setUpdateDetailsFlag] = useState(false);

  const {
    id: userId,
    accounts: { edges },
    roles,
    availableMultiFactorAuthenticationOptions,
    currentMultiFactorAuthenticationOption,
  } = user;

  const userRole = getRoleForCurrentAccount(roles, accountId);

  if (updateRolesFlag) {
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <UserDetailEdit
              accountId={accountId}
              userId={userId}
              userRole={userRole}
              toggleEdit={(value) => setUpdateRolesFlag(value)}
            />
          </div>
        </div>
      </div>
    );
  }

  if (changePasswordFlag) {
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <UserChangePassword
              accountId={accountId}
              userId={userId}
              toggleChangePassword={(value) => setChangePasswordFlag(value)}
            />
          </div>
        </div>
      </div>
    );
  }

  if (updateDetailsFlag) {
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <UserUpdateDetails
              accountId={accountId}
              userId={userId}
              availableMultiFactorAuthenticationOptions={availableMultiFactorAuthenticationOptions}
              currentMultiFactorAuthenticationOption={currentMultiFactorAuthenticationOption}
              toggleUpdateDetails={(value) => setUpdateDetailsFlag(value)}
            />
          </div>
        </div>
      </div>
    );
  }

  if (changeOwnerFlag) {
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <ChangeAccountOwner accountId={accountId} toggleChangeOwner={(value) => setChangeOwnerFlag(value)} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <UserDetailDisplay
            accountId={accountId}
            user={user}
            accountLegalName={accountLegalName}
            userRole={userRole}
            viewerRole={viewerRole}
            viewerId={viewerId}
            toggleChangePassword={(value) => setChangePasswordFlag(value)}
            toggleUpdateDetails={(value) => setUpdateDetailsFlag(value)}
            toggleChangeOwner={(value) => setChangeOwnerFlag(value)}
          />
          <div className="p-col-12">
            <CommunicationSettings userIsViewingOwnPage={userId === viewerId} accountId={accountId} edges={edges} />
          </div>
        </div>
      </div>
    </div>
  );
};

UserDetail.propTypes = {
  accountId: PropTypes.string.isRequired,
  user: PropTypes.objectOf(PropTypes.any).isRequired,
  viewerRole: PropTypes.string.isRequired,
  viewerId: PropTypes.string.isRequired,
};

export default UserDetail;
